import { useTranslation } from 'react-i18next';

import { useTheme } from 'styled-components';
import { Skeleton } from 'components';
import { CardBankSlipSelectorProps } from './CardBankSlipSelector.type';
import * as S from './CardBankSlipSelector.style';

const CardBankSlipSelectorDefault = ({ 
    onClickBankSlip = () => null, 
    selectedBankSlip = false, 
    hasError = false 
}: CardBankSlipSelectorProps) => {
    const { t } = useTranslation();

    const handleSelectBankSlip = () => {
        onClickBankSlip();
    };

    return (
        <S.CardBankSlipWrapper onClick={handleSelectBankSlip} isSelected={selectedBankSlip} hasError={hasError}>
            <S.CardBankSlipCheckbox isSelected={selectedBankSlip} hasError={hasError} />
            
            <S.CardBankSlipContent>
                <S.CardBankSlipTitle isSelected={selectedBankSlip}>
                    {t('subscriptionFormBankSlipTitle')}
                </S.CardBankSlipTitle>

                <S.CardBankSlipDescription isSelected={selectedBankSlip}>
                    {t('subscriptionFormBankSlipDescription')}
                </S.CardBankSlipDescription>
            </S.CardBankSlipContent>
        </S.CardBankSlipWrapper>
    );
};

const CardBankSlipSelectorLoading = () => {
    const theme = useTheme();

    return (
        <S.CardBankSlipWrapper isSelected={false} hasError={false}>
            <Skeleton width="1.5rem" height="1.5rem" style={{ borderRadius: '100%'}} />

            <S.CardBankSlipContent>
                <S.CardBankSlipTitle isSelected={false}>
                    <Skeleton width="8rem" height={theme.fontSizes[5]} />
                </S.CardBankSlipTitle>

                <S.CardBankSlipDescription isSelected={false}>
                    <Skeleton width="12rem" height={theme.fontSizes[8]} />
                </S.CardBankSlipDescription>
            </S.CardBankSlipContent>
        </S.CardBankSlipWrapper>
    );
};

export const CardBankSlipSelector = (props: CardBankSlipSelectorProps) => {
    if (props.isLoading) {
        return <CardBankSlipSelectorLoading />;
    }

    return <CardBankSlipSelectorDefault {...props} />;
};
